import { render } from "./EstudiosBeta.vue?vue&type=template&id=724f2791"
import script from "./EstudiosBeta.vue?vue&type=script&lang=js"
export * from "./EstudiosBeta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__